/* Eigen reviewblok op de productpagina.
   Drie kleine dingen: de eerste zes reviews tonen met een knop voor de rest,
   per review kunnen wisselen tussen de vertaling en het Nederlandse origineel,
   en de knop "schrijf een review" doorgeven aan het verborgen Judge.me-blok
   dat het formulier levert. */
(function () {
  var TOON = 6;

  function init() {
    var lijst = document.querySelector('[data-bl-reviews]');
    if (!lijst) return;

    var reviews = Array.prototype.slice.call(lijst.querySelectorAll('.bl-rev'));
    var meerKnop = document.querySelector('[data-bl-more]');

    if (reviews.length > TOON && meerKnop) {
      reviews.slice(TOON).forEach(function (r) { r.hidden = true; });
      meerKnop.hidden = false;
      meerKnop.addEventListener('click', function () {
        reviews.forEach(function (r) { r.hidden = false; });
        meerKnop.hidden = true;
      });
    }

    lijst.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-orig]');
      if (!knop) return;
      var body = knop.parentElement.querySelector('.bl-rev__body p');
      if (!body) return;
      var toontOrigineel = knop.getAttribute('data-toont') === 'orig';
      body.textContent = toontOrigineel ? knop.getAttribute('data-vert') : knop.getAttribute('data-orig');
      knop.setAttribute('data-toont', toontOrigineel ? 'vert' : 'orig');
      knop.classList.toggle('bl-rev__orig--actief', !toontOrigineel);
    });

    var schrijf = document.querySelector('[data-bl-write-review]');
    if (schrijf) {
      schrijf.addEventListener('click', function () {
        var app = document.querySelector('.bl-revs__app');
        var knopInApp = app && app.querySelector('.jm-button--primary, .jdgm-write-rev-link');
        if (knopInApp) {
          knopInApp.click();
        } else if (app) {
          // Nog niet geladen: blok zichtbaar maken zodat de bezoeker niet vastloopt
          app.removeAttribute('data-bl-app-hidden');
          app.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
